var _rect, _rect2, _rect3, _rect4, _rect5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentCenterActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.0918,
    y: 0.0488281,
    width: 21.5393,
    height: 28.0011,
    rx: 2,
    fill: "url(#paint0_linear_524_22794)",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 1.93994,
    width: 23.2624,
    height: 28.1088,
    rx: 3,
    fill: "url(#paint1_linear_524_22794)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.98438,
    y: 7.80273,
    width: 8.61572,
    height: 2.15393,
    rx: 1.07697,
    fill: "#E9F4FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.98438,
    y: 12.1108,
    width: 15.0775,
    height: 2.15393,
    rx: 1.07697,
    fill: "#E9F4FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.98438,
    y: 16.4185,
    width: 15.0775,
    height: 8.61572,
    rx: 1,
    fill: "#E9F4FF",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_524_22794",
    x1: 14.8614,
    y1: 0.0488281,
    x2: 14.8614,
    y2: 21.5881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E97EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DB9EE",
    stopOpacity: 0.51
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_524_22794",
    x1: 11.6312,
    y1: 1.93994,
    x2: 11.6312,
    y2: 30.0487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E97EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DB9EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCenterActive);
export default "https://cdn.d2cgo.com/dtc_center/v19/ma_assets/static/media/contentCenter_active.f56c6e21f37db9c82837941cc19535a6.svg";
export { ForwardRef as ReactComponent };